import { Component, Input, OnChanges } from '@angular/core';
import type { DateRange } from 'moment-range';

import { Form } from '@site-mate/dashpivot-shared-library';

import { ChartBreakdownStaticOptions } from 'app/shared/model/charts/chart-breakdown-static-options.model';
import { ChartColorScheme, SCurveScheme } from 'app/shared/model/charts/chart-color-scheme.model';
import { ChartSettings } from 'app/shared/model/charts/chart-settings.model';
import { ErrorHandler } from 'app/shared/service/error-handler.service';

import { QuantityChartDataService } from './quantity-chart-data.service';
import { ChartDataSettings } from '../../../shared/model/charts/chart-data-settings.model';

@Component({
  selector: 'cc-quantity-chart',
  templateUrl: './quantity-chart.component.html',
  styleUrls: ['./quantity-chart.component.scss'],
})
export class QuantityChartComponent implements OnChanges {
  @Input() chart: ChartSettings;
  @Input() forms: Form[] = [];
  @Input() dateRange: DateRange;
  @Input() loading: boolean;

  barChartData: any[] = [];
  lineChartData: any[] = [];

  // options
  view = [1240, 400];
  xAxisLabel = 'Time';
  yAxisLabel = 'Quantity';
  xAxisTickFormatter;
  xAxisTooltipFormatter;
  barPadding;
  showLegend;
  chartType;

  colorScheme = ChartColorScheme;
  sCurveColorScheme = SCurveScheme;

  constructor(
    private readonly errorHandler: ErrorHandler,
    private readonly quantityChartDataService: QuantityChartDataService,
  ) {}

  ngOnChanges() {
    if (this.loading) {
      return;
    }

    this.setChartLabels();

    this.yAxisLabel = this.getYAxisLabel();
    this.showLegend = this.chart.breakdownBy !== ChartBreakdownStaticOptions.none.value;

    try {
      const data = this.quantityChartDataService.parseForms(this.chart, this.forms, this.dateRange);
      this.barChartData = data.barChartData;
      this.lineChartData = data.lineChartData;
      this.chartType = this.chart.showAs;
    } catch (error) {
      this.errorHandler.handle(error);
    }
  }

  private getYAxisLabel(): string {
    const table = this.chart.template.items.find((templateItem) => templateItem._id === this.chart.itemId);

    if (!table) {
      return '';
    }

    const column = table.columns.find((itemColumn) => itemColumn._id === this.chart.columnId);

    if (!column) {
      return '';
    }

    return column.heading;
  }

  private setChartLabels() {
    const timeFrame = ChartDataSettings[this.chart.timeframe];

    if (timeFrame) {
      this.xAxisLabel = timeFrame.xAxisLabel;
      const interval = timeFrame.intervals[this.chart.dateUnit];

      if (interval) {
        this.xAxisTickFormatter = interval.xAxisTickFormatter;
        this.xAxisTooltipFormatter = interval.xAxisTooltipFormatter;
        this.barPadding = interval.barPadding;
      }
    }
  }
}
